import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6,
				marginTop: 10
			},
			header: {
				fontSize: 14,
				color: theme.palette.primary.contrastText,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`,
				paddingBottom: 10,
				fontWeight: 500,
				padding: 10
			},
			headerEnd: {
				textAlign: "end"
			},
			headerCenter: {
				color: theme.palette.error.light
			},
			content: {
				fontSize: 12,
				color: theme.palette.primary.contrastText,
				lineHeight: "18px"
			}
		}),
	{
		name: "TableLoyalty",
		index: 1
	}
);

export default useStyles;
